import React from "react";
import MUICircularProgress from "@mui/material/CircularProgress";
import { variables } from "../../assets/styles";
import styles from "./buttonLoader.module.scss";
const DIAMETER = {
    xs: variables.icon_size_xs,
    sm: variables.icon_size_sm,
    md: variables.icon_size_md,
    lg: variables.icon_size_lg,
    inherit: "1em",
};
const ButtonLoader = ({ children, size = "xs", }) => {
    return (React.createElement("div", { className: styles["button-loader"] },
        React.createElement(MUICircularProgress, { size: DIAMETER[size], thickness: 5 }),
        children && (React.createElement("span", { className: styles["button-loader-text"] }, children))));
};
export default ButtonLoader;
//# sourceMappingURL=ButtonLoader.js.map